<template>
    <div id="image-container">
        <div id="image-on" v-if="urlAvailable">
            <img :src="visibleUrl" />
        </div>
        <div id="image-off" v-else>
            <i class="icon-picture"></i>
            <p>No Images</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Thumbnail',
  props: {
    url: String,
    version: String
  },
  computed: {
    urlAvailable: function() {
      return this.url && this.url.trim() !== '';
    },
    visibleUrl: function() {
      return `${this.url}?version=${this.version}`;
    }
  }
};
</script>

<style scoped>
    #image-container{
        display: table;
        width: 100%;
        text-align: center;
        cursor: pointer;
    }
    #image-on img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center top
    }
    #image-container > div{
        height: 300px;
        display: table-cell;
        vertical-align: middle;
    }
    #image-off i{
        font-size: 110px;
        color: #ccc;
    }
    #image-off p{
        font-size: 19px;
        color: #aaa;
    }
</style>
